<script>
import { Container, Draggable } from "vue-smooth-dnd";
import moment from "moment";

export default {
  data() {
    return {
      moment: moment,
    };
  },
  props: {
    variant: {
      type: String,
      required: false,
    },
    list: {
      // type: Array,
      required: true,
    },
    selectedItem: {
      type: Object,
      required: true,
    },
    prevSelectedItem: {
      type: String,
      required: true,
    },
    setSelectedItems: {
      type: Function,
      required: true,
    },
    topbarControls: {
      type: Object,
      required: false,
    },
    item: {
      type: Object,
      required: false,
      default: () => {
        return {
          draggable: true,
        };
      },
    },
  },
  components: {
    Container,
    Draggable,
  },
  methods: {
    getChildPayload(itemIndex, list) {
      return list[itemIndex];
    },
    async onDrop(event, list) {
      let updatedList = await this.applyDrag(list, event);
      this.topbarControls.onDragUpdateFn(list, updatedList);
    },
    async applyDrag(arr, dragResult) {
      const { removedIndex, addedIndex, payload } = dragResult;
      if (removedIndex === null && addedIndex === null) return arr;

      const result = [...arr];
      let itemToAdd = payload;

      if (removedIndex !== null) {
        itemToAdd = result.splice(removedIndex, 1)[0];
      }

      if (addedIndex !== null) {
        result.splice(addedIndex, 0, itemToAdd);
      }
      return result;
    },
    async switchItem(val) {
      this.topbarControls.onSwitchItemFn(val);
    },
  },
};
</script>
<template>
  <div v-if="list && list.length">
    <Container
      tag="ul"
      class="list-unstyled chat-list"
      drag-handle-selector=".draggable-item-trigger-a"
      lock-axis="y"
      :drag-begin-delay="0"
      :get-child-payload="(itemIndex) => getChildPayload(itemIndex, list)"
      @drop="onDrop($event, list)"
    >
      <template v-if="item && item.draggable">
        <Draggable
          v-for="data of list"
          tag="li"
          :key="data.id"
          :class="{ active: data.id == selectedItem.id }"
        >
          <div
            @click="switchItem(data)"
            class="draggable-item-trigger-item"
            :style="
              (data.active && topbarControls.config.activeToggle) ||
              (data.practices &&
                data.practices.length &&
                data.practices.find(
                  (x) => x.practice_id == currentPractice.id
                ) &&
                data.practices.find((x) => x.practice_id == currentPractice.id)
                  .active)
                ? 'border-left: 5px solid #22b14c'
                : ''
            "
          >
            <div class="media">
              <div
                class="draggable-item-trigger-a draggable-item-trigger-container pl-3 handle"
                :class="{
                  'd-none': variant && variant == 'simple',
                  'd-none': item && item.draggable === false,
                }"
              >
                <div class="draggable-item-trigger"></div>
              </div>
              <div class="media-body overflow-hidden p-2">
                <div
                  class="text-truncate font-size-14 mb-0 px-0 flex"
                  v-if="
                    item.featuredIcon_position &&
                    item.featuredIcon_position === 'right'
                  "
                >
                  <template
                    v-if="
                      data.id == selectedItem.id
                        ? selectedItem.featured
                        : data.featured
                    "
                  >
                    <div
                      class="align-top col-11 p-0 ellipsis"
                      :style="
                        data &&
                        data.additionalProp1 &&
                        data.additionalProp1.global
                          ? data.practices &&
                            data.practices.find(
                              (x) => x.practice_id == currentPractice.id
                            ) &&
                            !data.practices.find(
                              (x) => x.practice_id == currentPractice.id
                            ).active
                            ? data.id !== selectedItem.id
                              ? 'color: gray'
                              : ''
                            : ''
                          : 'active' in data && !data.active
                          ? data.id !== selectedItem.id
                            ? 'color: gray'
                            : ''
                          : ''
                      "
                    >
                      {{
                        moment(data.title, "YYYY-MM-DD", true).isValid()
                          ? moment(new Date(data.title)).format("DD MMMM, YYYY")
                          : data.title
                      }}
                    </div>
                    <div>
                      <i
                        v-if="
                          data.id == selectedItem.id
                            ? selectedItem.featured
                            : data.featured
                        "
                        class="ri-star-fill mr-2"
                        style="color: gold"
                      ></i>
                    </div>
                  </template>
                  <template v-else>
                    <div
                      class="align-top p-0 ellipsis"
                      :style="
                        data &&
                        data.additionalProp1 &&
                        data.additionalProp1.global
                          ? data.practices &&
                            data.practices.find(
                              (x) => x.practice_id == currentPractice.id
                            ) &&
                            !data.practices.find(
                              (x) => x.practice_id == currentPractice.id
                            ).active
                            ? data.id !== selectedItem.id
                              ? 'color: gray'
                              : ''
                            : ''
                          : 'active' in data && !data.active
                          ? data.id !== selectedItem.id
                            ? 'color: gray'
                            : ''
                          : ''
                      "
                    >
                      {{
                        moment(data.title, "YYYY-MM-DD", true).isValid()
                          ? moment(new Date(data.title)).format("DD MMMM, YYYY")
                          : data.title
                      }}
                    </div>
                  </template>
                </div>
                <p class="text-truncate font-size-14 mb-0 px-2" v-else>
                  <i
                    v-if="
                      data.id == selectedItem.id
                        ? selectedItem.featured
                        : data.featured
                    "
                    class="ri-star-fill mr-2"
                    style="color: gold"
                  ></i>
                  <span
                    class="align-top"
                    :style="
                      data &&
                      data.additionalProp1 &&
                      data.additionalProp1.global
                        ? data.practices &&
                          data.practices.find(
                            (x) => x.practice_id == currentPractice.id
                          ) &&
                          !data.practices.find(
                            (x) => x.practice_id == currentPractice.id
                          ).active
                          ? data.id !== selectedItem.id
                            ? 'color: gray'
                            : ''
                          : ''
                        : 'active' in data && !data.active
                        ? data.id !== selectedItem.id
                          ? 'color: gray'
                          : ''
                        : ''
                    "
                  >
                    {{
                      moment(data.title, "YYYY-MM-DD", true).isValid()
                        ? moment(new Date(data.title)).format("DD MMMM, YYYY")
                        : data.title
                    }}
                  </span>
                </p>
              </div>
            </div>
          </div>
        </Draggable>
      </template>
      <template v-else>
        <li
          v-for="data of list"
          :key="data.id"
          :class="{ active: data.id == selectedItem.id }"
        >
          <div
            @click="switchItem(data)"
            class="draggable-item-trigger-item"
            :style="
              (data.active && topbarControls.config.activeToggle) ||
              (data.practices &&
                data.practices.length &&
                data.practices.find(
                  (x) => x.practice_id == currentPractice.id
                ) &&
                data.practices.find((x) => x.practice_id == currentPractice.id)
                  .active)
                ? 'border-left: 5px solid #22b14c'
                : ''
            "
          >
            <div class="media">
              <div
                class="draggable-item-trigger-a draggable-item-trigger-container pl-3 handle"
                :class="{
                  'd-none': variant && variant == 'simple',
                  'd-none': item && item.draggable === false,
                }"
              >
                <div class="draggable-item-trigger"></div>
              </div>
              <div class="media-body overflow-hidden p-2">
                <p class="text-truncate font-size-14 mb-0 px-2">
                  <i
                    v-if="
                      data.id == selectedItem.id
                        ? selectedItem.featured
                        : data.featured
                    "
                    class="ri-star-fill mr-2"
                    style="color: gold"
                  ></i>
                  <span
                    class="align-top"
                    :style="
                      data &&
                      data.additionalProp1 &&
                      data.additionalProp1.global
                        ? data.practices &&
                          data.practices.find(
                            (x) => x.practice_id == currentPractice.id
                          ) &&
                          !data.practices.find(
                            (x) => x.practice_id == currentPractice.id
                          ).active
                          ? data.id !== selectedItem.id
                            ? 'color: gray'
                            : ''
                          : ''
                        : 'active' in data && !data.active
                        ? data.id !== selectedItem.id
                          ? 'color: gray'
                          : ''
                        : ''
                    "
                  >
                    {{
                      moment(data.title, "YYYY-MM-DD", true).isValid()
                        ? moment(new Date(data.title)).format("DD MMMM, YYYY")
                        : data.title
                    }}
                  </span>
                </p>
              </div>
            </div>
          </div>
        </li>
      </template>
    </Container>
  </div>
  <div v-else>
    <p>No items found!</p>
  </div>
</template>

<style scoped>
.custom-bg-soft-secondary {
  background-color: #dadce3;
}
.custom-bg-soft-secondary:hover {
  color: white !important;
}
</style>
<style lang="scss" scoped>
.chat-list {
  li {
    .draggable-item-trigger-a {
      cursor: move;
    }
    .draggable-item-trigger-container {
      height: 40px;
      width: 60px;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: move;

      .draggable-item-trigger {
        width: 20px;
        height: 8px;
        border-top: 2px solid #333;
        border-bottom: 2px solid #333;
        margin-right: 16px;
      }
    }

    &:hover,
    &.active {
      .draggable-item-trigger {
        border-top-color: #fff;
        border-bottom-color: #fff;
      }
    }
  }
}

.draggable-item-trigger-item {
  display: block;
  transition: all 0.4s;
  border-top: 1px solid #eff2f7;
  border-radius: 4px;
  background-color: #fff;
  color: #333;
  &:hover {
    background-color: #005eb8;
    color: #f1f5f7;
  }
}

.list-unstyled {
  .active {
    .draggable-item-trigger-item {
      background-color: #005eb8;
      color: #f1f5f7;
    }
  }
}
.ellipsis {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
